import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData, generalItemUpload} from '../middleware/apiMiddleware';
import s from './ItemVideo.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {MyInput} from './Utilities/MyInput';
import {modifiedDate} from '../middleware/dateControl';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function ItemVideo(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [data, setData] = useState([]);
	
	const fetchData = async () => {
		getData('item/getVideoByItemId?itemId=' + itemId, navigate)
		.then(res => {
				setData(res.data.videos);			
			//console.log(res.data);
				setFetchCompleted(true);
			}
		);
	}
		
	const updateVideo = async(id, videoPath) => {
		let obj =  { id, videoPath }
		let res = await postData("item/updateVideo", obj, navigate); 
	}
	
	const createNew = async() => {
		let obj =  { itemId }
		let res = await postData("item/createVideo", obj, navigate); 		
		
		let id = res.data.id
		let result = {
			id, itemId, name:"", nameHk:"", videoPath:null, disabled:0
		}
		
		data.push(result)
		setData([...data])
	}
	
	const setDisabled = async(indexD, disabled) => {
		data[indexD].disabled = disabled
		setData([...data])
		
		if (data[indexD].disabled == 1) {
			let obj = data[indexD];
			await postData("item/disabledVideo", obj, navigate);
		} else {
			let obj = data[indexD];
			await postData("item/enabledVideo", obj, navigate);
		}
		
	}
	
	const updateVideoBasic = async(indexD) => {
		let obj = data[indexD];
		
		await postData("item/updateVideoBasic", obj, navigate);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div style={{marginBottom:"20px",border: "1px solid rgb(104, 162, 166)", borderRadius: ".25rem", background:"#bed9d7"}}>	
		<div className={s.mainHolder} style={{fontSize:"24px"}}>Videos</div>
		<div className={s.mainHolder}>
			<div className={s.rowHolder}>
				<div style={{flexBasis:"20px"}}>ID</div>
				<div style={{flexBasis:"200px"}}>Name</div>
				<div style={{flexBasis:"200px"}}>Name HK</div>
				<div style={{flexBasis:"180px"}}></div>
				<div style={{flexBasis:"200px"}}>Path</div>
			</div>
		
			{
				data.map((d, indexD)=>(<div>
					<div key={indexD} className={s.rowHolder}>
						<div style={{flexBasis:"20px"}}>{d.id}</div>
						<div style={{flexBasis:"200px"}}>
							<MyInput inputLabel={""} dataInput={d.name} changeAction={(e)=>{
								data[indexD]['name'] = e
								setData([...data])
							}} />
						</div>
						<div style={{flexBasis:"200px"}}>
							<MyInput inputLabel={""} dataInput={d.nameHk} changeAction={(e)=>{
								data[indexD]['nameHk'] = e
								setData([...data])
							}} />
						</div>
						<div style={{flexBasis:"50px"}}>
							<GreenButton overrideStyle={{padding:"2px"}}  isEnabled={true} clickedAction={()=>updateVideoBasic(indexD)} bText={"Update"} />
						</div>
						<div style={{flexBasis:"50px"}}>
							<RedButton overrideStyle={{padding:"2px"}}  isEnabled={d.disabled == 1} clickedAction={()=>{setDisabled(indexD, 1)}} bText={"disabled"} />
						</div>
						<div style={{flexBasis:"50px"}}>
							<BlueButton overrideStyle={{padding:"2px"}}  isEnabled={d.disabled == 0} clickedAction={()=>{setDisabled(indexD, 0)}} bText={"enable"} />
						</div>
						
						
						
						<div style={{display:"flex", alignItems:"center"}}>
							<label htmlFor={"video-upload-"+indexD}  className={s.custom_file_upload} style={{margin:"5px"}}>
								<input id={"video-upload-"+indexD} type="file" style={{display:"none"}} onChange={
									async (e) => {
										let path = await generalItemUpload(itemId, e.target.files[0], navigate);
										
										if (path) {
											updateVideo(d.id, path);
										}
									}} />
								Upload Video
							</label>					
						</div>			
					</div>	
					
					<div>
						{	
							(d.videoPath) && (<div style={{textAlign:"left", display:"flex"}}>
								<div style={{border:"2px solid green", borderRadius:"2px", display:"flex"}}>
									<video controls width="300"  style={{ border:"2px solid black", borderRadius:"2px"}}>
										<source src={d.videoPath} type=""/>
										Your browser does not support the video tag.
									</video>		
								</div>
							</div>)
						}
					</div>					
					
				</div>))
			}
			
			<div style={{borderTop:"1px solid #92a9aa", margin:"10px 0 0 0", padding:"5px 0", display:"flex", justifyContent:"center"}}>
				<GreenButton isEnabled={true} clickedAction={createNew} bText={"Create New"} />
			</div>
		</div>
	</div>);
	
}

